import type { DuplicateAction } from '../types';

interface DuplicateActionSelectProps {
  value: DuplicateAction;
  onChange: (action: DuplicateAction) => void;
}

export const DuplicateActionSelect: React.FC<DuplicateActionSelectProps> = ({
  value,
  onChange,
}) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as DuplicateAction)}
      className="rounded-md border border-gray-300 bg-white px-2 py-1 text-xs"
    >
      <option value="add">追加</option>
      <option value="overwrite">上書き</option>
      <option value="skip">スキップ</option>
    </select>
  );
};
